import setupRoutes from '@/router/routes/admin-routes/setup-routes'
import designRoutes from '@/router/routes/admin-routes/design-routes'
import customerRoutes from '@/router/routes/admin-routes/customers-routes'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

import managementRoutes from '@/router/routes/admin-routes/management-routes'
import marketingRoutes from '@/router/routes/admin-routes/marketing-routes'
import posRoutes from '@/router/routes/admin-routes/pos-routes'
import multiGuard from '@/router/utils/vue-router-multiguard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import authGuard from '@/router/guards/auth-guard'
import checkExpirationGuard from '@/router/guards/check-expiration-guard'
import checkUserTypeGuard from '@/router/guards/check-user-type-guard'
import HomeRedirect from '@/router/utils/home-redirect'
import fromRegisterGuard from '@/router/guards/from-register-guard'
import LayoutFull from '@/layouts/full/LayoutFull.vue'
import checkRouteQueryGuard from '@/router/guards/check-route-query-guard'
import marketingGuard from '@/router/guards/marketing-guard'
import shortcutGuard from '@/router/guards/shortcut-guard'
import mobileRoutes from '@/router/routes/admin-routes/mobile-routes'
import fetchBusinessTypesGuard from '@/router/guards/fetch-business-types-guard'
import inventoryRoutes from '@/router/routes/admin-routes/inventory-routes'
import reports from '@/router/routes/admin-routes/reports'
// import logsRoutes from '@/router/routes/admin-routes/logs-routes'

export default [
  {
    path: '/admin',
    component: LayoutFull,
    beforeEnter: multiGuard([checkTokenGuard, authGuard, checkUserTypeGuard, checkExpirationGuard, checkRouteQueryGuard, marketingGuard, shortcutGuard]),
    children: [
      {
        path: '',
        name: 'admin:home',
        redirect: HomeRedirect,
      },
      {
        path: 'dashboard',
        name: 'admin:dashboard',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/admin/dashboard/DashboardView.vue'),
      },
      {
        path: 'devices',
        name: 'admin:display-devices',
        meta: { permission: SUBUSER_PERMISSION_SLUGS.DISPLAY_DEVICES_VIEW },
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/admin/display-devices/DevicesTable.vue'),
      },
      {
        path: 'settings',
        beforeEnter: multiGuard([fetchBusinessTypesGuard]),
        name: 'admin:settings',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/admin/settings/SettingsForm.vue'),
      },
      {
        path: 'payment-links',
        name: 'admin:payment-links',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/admin/payment-links/PaymentLinks.vue'),
      },
      {
        path: 'branches-management',
        name: 'admin:branches-management',
        component: () => import(/* webpackChunkName: "statistics" */ '@/views/admin/branches-management/BranchesManagement.vue'),
      },
      {
        path: 'profile',
        name: 'admin:profile',
        component: () => import(/* webpackChunkName: "MyProfile" */ '@/views/admin/user/MyProfile.vue'),
      },
      {
        path: 'welcome',
        name: 'admin:welcome',
        beforeEnter: fromRegisterGuard,
        component: () => import(/* webpackChunkName: "welcome" */ '@/views/admin/welcome/WelcomeWizard.vue'),
      },
      {
        path: 'setup',
        component: { render: (h: any) => h('router-view') },
        children: setupRoutes,
      },
      {
        path: 'design',
        component: { render: (h: any) => h('router-view') },
        children: designRoutes,
      },
      {
        path: 'management',
        component: { render: (h: any) => h('router-view') },
        children: managementRoutes,
      },
      {
        path: 'marketing',
        component: { render: (h: any) => h('router-view') },
        children: marketingRoutes,
      },
      {
        path: 'mobile',
        component: { render: (h: any) => h('router-view') },
        children: mobileRoutes,
      },
      {
        path: 'customers',
        component: { render: (h: any) => h('router-view') },
        children: customerRoutes,
      },
      {
        path: 'pos',
        component: { render: (h: any) => h('router-view') },
        children: posRoutes,
      },
      {
        path: 'inventory',
        component: { render: (h: any) => h('router-view') },
        children: inventoryRoutes,
      },
      {
        path: 'reports',
        component: { render: (h: any) => h('router-view') },
        children: reports,
      },
      // {
      //   path: 'logs',
      //   component: { render: (h: any) => h('router-view') },
      //   meta: { userTypes: [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN] },
      //   children: logsRoutes,
      // },
      {
        path: 'shortcuts',
        name: 'admin:shortcuts',
        component: () => import(/* webpackChunkName: "inventory" */ '@/@okmenu/components/cards/Shortcuts.vue'),
      },
    ],
  },

]
